export const JobBiddingStageConstants = {
    NOT_ANSWERED: 'NOT_ANSWERED',
    MADE_BID: 'MADE_BID',
    REJECTED: 'REJECTED'
};
